import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spin, Result } from 'antd';
import axios from 'axios';

const LinkRedirect = () => {
    const { slug } = useParams();
    const [error, setError] = useState(false);

    useEffect(() => {
        const resolve = async () => {
            try {
                const response = await axios.get(`/l/${slug}/`);
                if (response?.data?.url) {
                    window.location.href = response.data.url;
                } else {
                    setError(true);
                }
            } catch (err) {
                setError(true);
            }
        };
        resolve();
    }, [slug]);

    if (error) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Result
                    status="404"
                    title="Link Not Found"
                    subTitle="This link does not exist or you do not have access to it."
                />
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Spin size="large" tip="Redirecting..." />
        </div>
    );
};

export default LinkRedirect;
